export default {
    auth: {
        login: 'เข้าสู่ระบบ',
        email: 'อีเมล์',
        password: 'รหัสผ่าน',
        confirm_password: 'ยืนยันรหัสผ่าน',
        signup: 'ลงทะเบียน',
        forget_password: 'ลืมรหัสผ่าน?',
        forgot_password: {
            title: 'รีเซ็ตรหัสผ่าน',
            enter_email_reset_password: 'กรอกอีเมล์เพื่อรีเซ็ตรหัสผ่าน',
            next: 'ถัดไป',
            success: 'กรุณาตรวจสอบอีเมล์ของคุณ',
            back_to_login: 'กลับไปหน้าเข้าสู่ระบบ',
        },
        two_factor: {
            signing_in_as: 'กำลังเข้าสู่ระบบด้วย {email}',
            setup_for: 'กำลังตั้งค่า 2FA ของ {email}',
            back_to_login: 'กลับไปหน้าเข้าสู่ระบบ',
            skip: 'ข้าม 2FA',
        },
        domain_access_denied: 'บัญชีนี้ไม่สามารถเข้าใช้งานจากโดเมนนี้ได้',
        account_locked: 'บัญชีของคุณถูกระงับการใช้งานชั่วคราว กรุณาติดต่อผู้ดูแลระบบ',
    },
    menu: {
        agent_account: 'Org. Management',
        org_hierarchy: 'Network Management',
    },
    manage: {
        org_hierarchy: {
            title: 'Network Management',
            filter: {
                search: 'ค้นหาชื่อ, Tax ID, หรือ Org ID',
                hierarchy: 'ลำดับชั้น',
                status: 'สถานะ',
                search_btn: 'ค้นหา',
            },
            headers: {
                id: 'ID',
                name: 'องค์กร',
                tax_id: 'Tax ID',
                status: 'สถานะ',
                parent: 'องค์กรแม่',
                children_count: 'องค์กรลูก',
                commission_rate: 'อัตราคอม.',
                created_date: 'วันที่สร้าง',
            },
            actions: {
                view: 'ดูรายละเอียด',
                assign: 'เพิ่มองค์กรลูก',
                detach: 'ถอดองค์กรลูก',
            },
            detail: {
                title: 'รายละเอียดองค์กร',
                org_id: 'รหัสองค์กร',
                name: 'ชื่อองค์กร',
                tax_id: 'Tax ID',
                status: 'สถานะ',
                commission_rate: 'อัตราคอมมิชชั่น',
                parent: 'องค์กรแม่',
                no_parent: 'ไม่มีองค์กรแม่',
                children: 'องค์กรลูก',
                no_children: 'ไม่มีองค์กรลูก',
            },
            assign: {
                title: 'เพิ่มองค์กรลูก',
                parent_org: 'องค์กรแม่',
                search_children: 'ค้นหาองค์กรที่ต้องการเพิ่ม...',
                selected: 'องค์กรที่เลือก',
                no_results: 'ไม่พบองค์กร',
                confirm: 'เพิ่ม',
                success: 'เพิ่มองค์กรลูกสำเร็จ',
            },
            detach: {
                title: 'ถอดองค์กรลูก',
                parent_org: 'องค์กรแม่',
                select_children: 'เลือกองค์กรลูกที่ต้องการถอด',
                select_all: 'เลือกทั้งหมด',
                confirm: 'ถอด',
                success: 'ถอดองค์กรลูกสำเร็จ',
            },
            cancel: 'ยกเลิก',
        },
        booking: {
            layered: {
                tabs: {
                    pending: 'รอรับทราบยอดโอน',
                    inventory: 'รายการในมือ',
                    tracking: 'ติดตามในเครือข่าย',
                },
                empty: {
                    pending: 'ไม่มีรายการที่รอการรับทราบจากคุณ',
                    inventory: 'ไม่มีรายการที่ถืออยู่',
                    tracking: 'ไม่มีรายการในเครือข่ายของคุณ',
                },
                col: {
                    reservation: 'หมายเลขจอง',
                    payment_no: 'งวด',
                    amount: 'จำนวนเงิน',
                    booking: 'การจอง',
                    status: 'สถานะ',
                    held_at: 'อยู่ที่',
                    submitter: 'ผู้ส่ง',
                },
                action: {
                    approve: 'รับทราบการรับเงิน',
                    approve_bundle: 'รับทราบทั้งชุด ({count})',
                    reject: 'ปฏิเสธ',
                    reject_bundle: 'ปฏิเสธทั้งชุด ({count})',
                    forward: 'ส่งต่อรายการที่เลือก',
                    forward_short: 'ส่งต่อ',
                    view_chain: 'ดูเส้นทาง',
                },
                bundle: {
                    label: 'ชุดเดียวกัน {count} รายการ',
                    tooltip_title: 'ส่งมาพร้อมกันใน transfer เดียว:',
                    this_row: 'แถวนี้',
                },
                slip_from: 'สลิปจาก',
                inventory_hint: 'เลือกรายการที่ถืออยู่เพื่อส่งต่อขึ้นชั้นบนพร้อมแนบสลิปของคุณ',
                inventory_staff_hint:
                    'รายการเหล่านี้อยู่ที่องค์กร staff แล้ว ใช้ขั้นตอนการชำระเงินเดิมด้านบนเพื่อยืนยันกับ PHP',
                dialog: {
                    reject_title: 'ปฏิเสธการโอน',
                    reject_note: 'เหตุผล (จำเป็น)',
                    forward_title: 'ส่งต่อขึ้นชั้นบน',
                    forward_summary: 'รายการที่จะส่งต่อ',
                    payment_method: 'วิธีการชำระเงิน',
                    forward_note: 'หมายเหตุ (ไม่บังคับ)',
                    upload_slip: 'สลิปของคุณ',
                    chain_title: 'เส้นทางการโอน',
                    held_at: 'ปัจจุบันอยู่ที่',
                    slip_private: 'ส่วนตัว — ไม่แชร์สลิป',
                    holder_private: 'ส่งต่อขึ้นชั้นบน (ปกปิด)',
                    no_slip: 'ไม่มีสลิปแนบ',
                },
                status: {
                    pending: 'รอดำเนินการ',
                    approved: 'อนุมัติแล้ว',
                    rejected: 'ปฏิเสธ',
                    awaiting_parent_approval: 'รอการรับทราบจากชั้นบน',
                    held: 'ถืออยู่',
                    in_transit_to_php: 'กำลังส่งไป PHP',
                    confirmed_core: 'ยืนยันสำเร็จ',
                    returned_to_submitter: 'ส่งคืนผู้ส่งต้นทาง',
                },
                toast: {
                    approve_success: 'รับทราบการโอนเรียบร้อย',
                    reject_success: 'ปฏิเสธการโอนเรียบร้อย',
                    forward_success: 'ส่งต่อรายการเรียบร้อย',
                    generic_error: 'ดำเนินการไม่สำเร็จ กรุณาลองใหม่',
                },
                rollback: {
                    button: 'ล้างประวัติ / Rollback',
                    title: 'ล้างประวัติและ rollback การจ่ายเงิน',
                    description:
                        'การกระทำนี้เป็นแบบทำลายข้อมูล เลือก scope แยกตาม payment type ได้ "Roll back all" จะลบ chain ฝั่ง B2B ทั้งหมด (รายการ, การโอน, สลิป) ของ payment type นั้น และทำได้เฉพาะกรณีที่ทุก reservation ของ type นั้นยังเป็น Open อยู่ในฝั่ง B2C เท่านั้น ส่วน "ลบเฉพาะประวัติที่ถูก reject" จะลบเฉพาะรายการที่ถูกปฏิเสธโดยไม่กระทบรายการที่ยัง active',
                    loading: 'กำลังโหลดข้อมูล rollback...',
                    no_data: 'ไม่พบข้อมูล payment ของ booking นี้',
                    column: {
                        payment_type: 'Payment type',
                        b2c_state: 'สถานะฝั่ง B2C',
                        b2b_state: 'B2B chain',
                        scope: 'Action',
                    },
                    scope: {
                        skip: 'ข้าม',
                        rejected_only: 'ลบเฉพาะประวัติที่ถูก reject',
                        all: 'Roll back ทั้งหมด (ลบ chain ทั้งหมด)',
                    },
                    b2c_state_summary: '{open}/{total} reservation ยังเป็น Open',
                    b2c_finalized_label: 'finalize ไปแล้ว',
                    b2b_state_summary: '{items} รายการ, {rejected} transfer ถูก reject',
                    affected_label: 'รายการที่จะถูกกระทบจาก action ที่เลือก',
                    action_label: {
                        all: 'Rollback ทั้งหมด',
                        rejected_only: 'ลบประวัติ reject',
                    },
                    confirm_uid_prompt: 'พิมพ์ booking UID นี้เพื่อยืนยัน:',
                    confirm_uid_hint: 'คัดลอกค่าด้านบน (หรือกดไอคอน copy) แล้ววางลงในช่องด้านล่างให้ตรงทุกตัวอักษร',
                    confirm_uid_label: 'ยืนยัน booking UID',
                    copy_uid: 'คัดลอก booking UID',
                    copied: 'คัดลอก booking UID แล้ว',
                    submit: 'ยืนยันการ rollback',
                    success: 'Rollback สำเร็จ',
                },
            },
            item: {
                payment: {
                    contract_new: 'New',
                    headers: {
                        commission: 'คอมมิชชั่น',
                        reject_reason: 'เหตุผลการปฏิเสธ',
                    },
                    reject_reason_title: 'เหตุผลการปฏิเสธ',
                    reject_reason_close: 'ปิด',
                    reject_dialog_title: 'ปฏิเสธการรับเงิน',
                    reject_dialog_reason: 'เหตุผลการปฏิเสธ (จำเป็น)',
                    deposit_required_for_balance_approval: 'ไม่สามารถอนุมัติยอด Balance ได้เนื่องจากยอด Deposit ยังไม่ได้รับการอนุมัติ',
                },
            },
        },
    },
    common: {
        cancel: 'ยกเลิก',
        close: 'ปิด',
        confirm: 'ยืนยัน',
        save: 'บันทึก',
        submit: 'ส่ง',
        ok: 'ตกลง',
    },
}